import React, { Component } from "react";
import PropTypes from "prop-types";

import LineSeries from "./LineSeries";
import StraightLine from "./StraightLine";

class ForceIndex2AvgsSeries extends Component {
  constructor(props) {
    super(props);
    this.yAccessorForM1 = this.yAccessorForM1.bind(this);
    this.yAccessorForM2 = this.yAccessorForM2.bind(this);
  }
  yAccessorForM1(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).m1;
  }
  yAccessorForM2(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).m2;
  }
  render() {
    const { className, onDoubleClick, onContextMenu } = this.props;
    const { strokeM1, strokeM2, strokeZeroLine } = this.props;

    return (
      <g className={className}>
        <LineSeries
          yAccessor={this.yAccessorForM1}
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={strokeM1}
        />
        <LineSeries
          yAccessor={this.yAccessorForM2}
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={strokeM2}
        />
        <StraightLine
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={strokeZeroLine}
          yValue={0}
        />
      </g>
    );
  }
}

ForceIndex2AvgsSeries.propTypes = {
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  strokeM1: PropTypes.object.isRequired,
  strokeM2: PropTypes.object.isRequired,
  strokeZeroLine: PropTypes.object.isRequired,
  onDoubleClick: PropTypes.func,
  onContextMenu: PropTypes.func,
};

ForceIndex2AvgsSeries.defaultProps = {
  className: "react-stockcharts-force-index-2avgs-series",
};

export default ForceIndex2AvgsSeries;
